import { render, staticRenderFns } from "./rename.vue?vue&type=template&id=e36fcb06&scoped=true&"
import script from "./rename.vue?vue&type=script&lang=js&"
export * from "./rename.vue?vue&type=script&lang=js&"
import style0 from "./rename.vue?vue&type=style&index=0&id=e36fcb06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36fcb06",
  null
  
)

export default component.exports